import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { Tenant } from '../types';

interface TenantState {
  selectedTenantId: string | null;
  tenants: Tenant[];
  setSelectedTenant: (id: string | null) => void;
  setTenants: (tenants: Tenant[]) => void;
}

export const useTenantStore = create<TenantState>()(
  persist<TenantState>(
    (set) => ({
      selectedTenantId: null,
      tenants: [],
      setSelectedTenant: (id: string | null) => set({ selectedTenantId: id }),
      setTenants: (tenants: Tenant[]) => set({ tenants }),
    }),
    {
      name: 'nzt:selected_tenant',
    }
  )
);
